import { defineMessages } from 'react-intl'

const messages = {
  ariaLabel: {
    id: 'app.components.search-button.aria-label',
    defaultMessage: 'Search button',
  },
}

export default defineMessages(messages)
